import { useState } from 'react';
import { RegistrationTargetImage } from './registrationTargetImage';

/**
 * The user's choice of target image, resolved against the current
 * candidates: a choice whose image leaves the list is dropped, and stays
 * dropped if the image returns, and a single candidate is chosen for the
 * user. With several candidates nothing is chosen until the user picks one.
 */
export function useTargetImageChoice(
    candidates: RegistrationTargetImage[]
): [
    RegistrationTargetImage | undefined,
    (image: RegistrationTargetImage | undefined) => void,
] {
    const [chosenSeriesId, setChosenSeriesId] = useState<string>();
    const chosenCandidate = candidates.find(
        (image) => image.seriesId === chosenSeriesId
    );
    if (chosenSeriesId !== undefined && !chosenCandidate) {
        setChosenSeriesId(undefined);
    }
    const chosen =
        chosenCandidate ??
        (candidates.length === 1 ? candidates[0] : undefined);
    return [chosen, (image) => setChosenSeriesId(image?.seriesId)];
}
